module.exports = __webpack_public_path__ + "img/1501770447.260f7424.jpg";